import React from 'react';
import ReactDOM from 'react-dom/client';

import { WebCallApp } from './WebCallApp';
import './styles.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode >
        <WebCallApp / >
    </React.StrictMode>
);